// src/pages/Service/Service.tsx
import React from 'react';
import HeadCommon from '../../components/HeadCommon';

const Service: React.FC = () => {
  return (
    <>
    <HeadCommon />
    <main
      className="Service-page other-page"
    >
      <h1>利用規約</h1>
      <section className="terms-of-service">
        <h2>1. はじめに</h2>
        <p>
          本利用規約（以下「本規約」）は、autoChat AI（以下「当社」）が提供するWebアプリ「autoChat AI」（以下「本サービス」）の利用条件を定めるものです。本サービスを利用することで、本規約に同意したものとみなされます。
        </p>

        <h2>2. サービス内容</h2>
        <p>
          本サービスは、複数のツールを提供し、ユーザーがテキストやファイルを入力することによってOpenAIのAPIと通信し、結果をフロントエンドに返します。ユーザーは、無料および有料のプランに基づいてサービスを利用できます。
        </p>

        <h2>3. ユーザー登録</h2>
        <p>
          ユーザーは、正確かつ最新の情報を提供してアカウントを作成する必要があります。アカウント情報の不正使用に関しては、ユーザー自身が責任を負います。
        </p>

        <h2>4. 料金およびプラン</h2>
        <p>
          Basicプラン：月額1,500円 〜 6,000円（税込）
          <br />
          Premiumプラン：月額3,500円 〜 14,000円（税込）
        </p>

        <h2>5. 利用制限</h2>
        <p>
          当社は、ユーザーが本規約に違反した場合、事前の通知なくアカウントを停止または削除する権利を有します。
        </p>

        <h2>6. 知的財産権</h2>
        <p>
          本サービスに関する全ての知的財産権は、当社またはそのライセンサーに帰属します。ユーザーは、本サービスを利用することで知的財産権を侵害しないことに同意します。
        </p>

        <h2>7. 免責事項</h2>
        <p>
          当社は、本サービスの内容の正確性、完全性、有用性について保証しません。また、ユーザーが本サービスを利用することによって生じた損害について、一切の責任を負いません。
        </p>

        <h2>8. 利用規約の変更</h2>
        <p>
          当社は、必要に応じて本規約を変更することがあります。重要な変更がある場合は、ユーザーに通知します。
        </p>

        <h2>9. 準拠法および裁判管轄</h2>
        <p>
          本規約は、日本法に準拠します。本規約に関する紛争は、東京地方裁判所を専属的な第一審の管轄裁判所とします。
        </p>

        <h2>10. お問い合わせ</h2>
        <p>利用規約に関するお問い合わせは、以下の連絡先までお願いします。</p>
        <p>
          メールアドレス:{' '}
          <a href="mailto:support@auto-chat.ai">support@auto-chat.ai</a>
        </p>
      </section>
    </main>
    </>
  );
};

export default Service;
